/* gr-cart-drawer.js — GothRider cart drawer.
 * No build step. Vanilla JS. Uses Shopify Ajax API (/cart.js, /cart/add.js,
 * /cart/change.js, /recommendations/products.json).
 *
 * Auto-hooks:
 *   - any <a href^="/cart"> (without data-gr-cart-skip) → drawer open
 *   - any [data-gr-cart-open] click → drawer open
 *   - any <form action^="/cart/add"] submit → ajax add + drawer open
 *
 * Events:
 *   window.dispatchEvent(new CustomEvent('gr:cart:open'))    // open
 *   window.dispatchEvent(new CustomEvent('gr:cart:refresh')) // re-render
 *
 * Bundle/kit parents are identified by line-item property `_bundle_children`
 * (JSON array) OR `_bundle_label` (human string). The drawer shows the parent
 * line only and surfaces the child count under the title.
 */
(function () {
  'use strict';

  var drawer = document.getElementById('gr-cart-drawer');
  if (!drawer) return;

  var body = document.body;
  // Locale-aware root URL (e.g., "/fr" or "/")
  var ROOT = (drawer.dataset.rootUrl || '/').replace(/\/+$/, '');
  // Threshold is now on the shipping_bar block element, read dynamically
  var THRESHOLD = 0; // will be set from block data attribute
  // Upsell config is now on the upsell block element, read dynamically
  function getUpsellConfig() {
    var upsellEl = drawer.querySelector('[data-gr-cart-upsell]');
    if (!upsellEl) return { enabled: false };
    return {
      enabled: true,
      mode: upsellEl.dataset.upsellMode || 'collection',
      collection: upsellEl.dataset.upsellCollection || 'coffee-bags',
      products: (upsellEl.dataset.upsellProducts || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean),
      limit: parseInt(upsellEl.dataset.upsellLimit, 10) || 3
    };
  }

  // Elements
  var el = {
    count: drawer.querySelector('[data-gr-cart-count]'),
    progress: drawer.querySelector('[data-gr-cart-progress]'),
    progressMsg: drawer.querySelector('[data-gr-cart-progress-msg]'),
    progressFill: drawer.querySelector('[data-gr-cart-progress-fill]'),
    lines: drawer.querySelector('[data-gr-cart-lines]'),
    empty: drawer.querySelector('[data-gr-cart-empty]'),
    emptyGrid: drawer.querySelector('[data-gr-cart-empty-grid]'),
    upsell: drawer.querySelector('[data-gr-cart-upsell]'),
    upsellGrid: drawer.querySelector('[data-gr-cart-upsell-grid]'),
    sub: drawer.querySelector('[data-gr-cart-sub]'),
    subToggle: drawer.querySelector('[data-gr-cart-sub-toggle]'),
    discountBlock: drawer.querySelector('[data-gr-cart-discount-block]'),
    foot: drawer.querySelector('[data-gr-cart-foot]'),
    subtotal: drawer.querySelector('[data-gr-cart-subtotal]'),
    tpl: document.getElementById('gr-cart-line-tpl'),
  };

  // ─── Money formatting ────────────────────────────────────────
  var CURRENCY = drawer.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  // ─── Open / close ────────────────────────────────────────────
  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('gr-cart-open');
    render();
    loadUpsells();
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('gr-cart-open');
  }

  drawer.querySelectorAll('[data-gr-cart-close]').forEach(function (n) {
    n.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });
  window.addEventListener('gr:cart:open', open);
  window.addEventListener('gr:cart:refresh', render);

  // ─── Global ATC interception ─────────────────────────────────
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-gr-cart-open]');
    if (!opener) {
      var link = e.target.closest('a[href]');
      if (link) {
        var href = (link.getAttribute('href') || '').replace(/^https?:\/\/[^/]+/, '');
        if (/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart(\?.*)?$/.test(href)) opener = link;
      }
    }
    if (opener && !opener.hasAttribute('data-gr-cart-skip')) {
      e.preventDefault();
      open();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = (form.getAttribute('action') || '').replace(/^https?:\/\/[^/]+/, '');
    if (!/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/add/.test(action)) return;
    if (form.hasAttribute('data-gr-cart-skip')) return;
    e.preventDefault();
    ajaxAdd(form);
  });

  function ajaxAdd(form) {
    var fd = new FormData(form);
    fetch(ROOT + '/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (d) { throw new Error(d.description || d.message || 'Add to cart failed'); });
        }
        return r.json();
      })
      .then(function () { open(); })
      .catch(function (err) { console.warn('[gr-cart] add failed', err); });
  }

  // ─── Fetch + render ──────────────────────────────────────────
  var cartCache = null;
  function fetchCart() {
    return fetch(ROOT + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function render() {
    return fetchCart().then(function (cart) {
      cartCache = cart;
      paint(cart);
    });
  }

  function paint(cart) {
    // Update currency from cart (respects Shopify Markets)
    if (cart.currency) CURRENCY = cart.currency;
    // Update ALL cart count badges (header + drawer)
    document.querySelectorAll('[data-gr-cart-count]').forEach(function(n) {
      n.textContent = cart.item_count;
    });

    if (cart.item_count === 0) {
      el.empty.hidden = false;
      el.lines.hidden = true;
      el.upsell.hidden = true;
      el.sub.hidden = true;
      el.foot.hidden = true;
      if (el.discountBlock) el.discountBlock.hidden = true;
      el.progress.hidden = true;
      loadEmptyPicks();
      return;
    }

    el.empty.hidden = true;
    el.lines.hidden = false;
    el.foot.hidden = false;
    if (el.discountBlock) el.discountBlock.hidden = false;

    // Progress — read threshold per currency from block data attribute
    // Format: "CAD:7500|USD:6000|EUR:5000"
    if (el.progress) {
      var thresholds = {};
      var firstThreshold = 0;
      (el.progress.dataset.thresholds || '').split('|').forEach(function (pair) {
        var parts = pair.trim().split(':');
        if (parts.length === 2) {
          var val = parseInt(parts[1].trim(), 10) || 0;
          thresholds[parts[0].trim().toUpperCase()] = val;
          if (!firstThreshold) firstThreshold = val;
        }
      });
      var blockThreshold = thresholds[CURRENCY] || firstThreshold || 0;

      if (blockThreshold > 0) {
        el.progress.hidden = false;
        var pct = Math.min(100, (cart.total_price / blockThreshold) * 100);
        el.progressFill.style.width = pct + '%';
        if (cart.total_price >= blockThreshold) {
          el.progress.classList.add('is-unlocked');
          el.progressMsg.textContent = '';
          el.progressMsg.insertAdjacentText('beforeend', el.progress.dataset.messageUnlocked || '✦ FREE SHIPPING UNLOCKED!');
        } else {
          el.progress.classList.remove('is-unlocked');
          var remaining = money(blockThreshold - cart.total_price);
          var progressMsg = el.progress.dataset.messageProgress || 'Add {amount} for FREE SHIPPING';
          var parts = progressMsg.split('{amount}');
          el.progressMsg.textContent = '';
          var iconSpan = document.createElement('span');
          iconSpan.className = 'ship-icon';
          iconSpan.textContent = '📦';
          el.progressMsg.appendChild(iconSpan);
          el.progressMsg.insertAdjacentText('beforeend', parts[0] || '');
          var amountSpan = document.createElement('span');
          amountSpan.className = 'amount';
          amountSpan.textContent = remaining;
          el.progressMsg.appendChild(amountSpan);
          el.progressMsg.insertAdjacentText('beforeend', parts[1] || '');
        }
      } else {
        el.progress.hidden = true;
      }
    }

    // Subtotal + discount display
    el.subtotal.textContent = money(cart.total_price);

    // Show cart-level discounts (skip if user just removed it)
    var discountRow = drawer.querySelector('[data-gr-cart-discount-row]');
    var totalDiscount = discountRemoved ? 0 : (cart.total_discount || 0);
    if (!discountRow) {
      discountRow = document.createElement('div');
      discountRow.className = 'gr-cart__discount-info';
      discountRow.setAttribute('data-gr-cart-discount-row', '');
      var totalsEl = el.foot.querySelector('.gr-cart__totals');
      if (totalsEl) totalsEl.parentNode.insertBefore(discountRow, totalsEl.nextSibling);
    }
    if (totalDiscount > 0) {
      var discountNames = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; });
      var label = discountNames.length ? discountNames.join(', ') : 'Discount';
      discountRow.textContent = '';

      // Top line: code pill with ✕ on left, discount amount on right
      var topLine = document.createElement('div');
      topLine.className = 'gr-cart__discount-top';

      var pillSpan = document.createElement('span');
      pillSpan.className = 'gr-cart__discount-pill';
      var pillText = document.createElement('span');
      pillText.textContent = label;
      pillSpan.appendChild(pillText);
      var removeDiscBtn = document.createElement('button');
      removeDiscBtn.type = 'button';
      removeDiscBtn.className = 'gr-cart__discount-pill-x';
      removeDiscBtn.textContent = '✕';
      removeDiscBtn.setAttribute('aria-label', 'Remove discount');
      removeDiscBtn.addEventListener('click', function () {
        discountRemoved = true;
        document.cookie = 'discount_code=; path=/; max-age=0';
        fetch(ROOT + '/checkout?discount=', { method: 'GET', redirect: 'manual' }).catch(function () {});
        discountRow.hidden = true;
        if (discountApplied) { discountApplied.hidden = true; discountApplied.textContent = ''; }
        render();
      });
      pillSpan.appendChild(removeDiscBtn);
      topLine.appendChild(pillSpan);

      var amountSpan = document.createElement('span');
      amountSpan.className = 'gr-cart__discount-amount';
      amountSpan.textContent = '−' + money(totalDiscount);
      topLine.appendChild(amountSpan);

      discountRow.appendChild(topLine);
      discountRow.hidden = false;
    } else {
      discountRow.hidden = true;
    }

    // Lines
    el.lines.innerHTML = '';
    cart.items.forEach(function (it) { el.lines.appendChild(buildLine(it)); });

    // Subscribe upsell: show if any line is one-time (selling_plan_allocation == null)
    // AND the product has subscription selling plans available (we infer via cart item).
    var hasOneTimeCoffee = cart.items.some(function (it) {
      return !it.selling_plan_allocation && /coffee|roast|blend/i.test(it.product_type || '');
    });
    el.sub.hidden = !hasOneTimeCoffee;
  }

  function buildLine(item) {
    var li = el.tpl.content.firstElementChild.cloneNode(true);
    li.dataset.key = item.key;

    var img = li.querySelector('[data-gr-cart-line-img]');
    var imgEl = img.querySelector('img');
    img.href = item.url;
    imgEl.src = item.image || '';
    imgEl.alt = item.product_title;

    var title = li.querySelector('[data-gr-cart-line-title]');
    title.textContent = item.product_title;
    title.href = item.url;

    // Variant meta (roast, grind, size)
    var metaBits = [];
    var bundleTag = '';
    if (item.variant_title && item.variant_title !== 'Default Title') metaBits.push(item.variant_title);
    // surface a couple line-item-properties (grind, size) if present
    (item.properties || {}) && Object.keys(item.properties || {}).forEach(function (k) {
      if (k.indexOf('_') === 0) return; // hidden
      var v = item.properties[k];
      if (!v) return;
      if (k === 'Bundle') {
        bundleTag = v;
      } else {
        metaBits.push(k + ': ' + v);
      }
    });
    var metaEl = li.querySelector('[data-gr-cart-line-meta]');
    metaEl.textContent = metaBits.join(' · ');
    if (bundleTag) {
      var tagSpan = document.createElement('div');
      tagSpan.className = 'gr-cart-line__bundle-tag';
      tagSpan.textContent = bundleTag;
      metaEl.parentNode.insertBefore(tagSpan, metaEl.nextSibling);
    }

    // Autoship pill — use selling plan name from API (translated via locale)
    if (item.selling_plan_allocation) {
      var pill = li.querySelector('[data-gr-cart-line-autoship]');
      var sp = item.selling_plan_allocation.selling_plan;
      if (sp && sp.name) pill.textContent = sp.name;
      pill.hidden = false;
    }

    // Bundle label (parent line only)
    var bundleChildren = (item.properties || {})['_bundle_children'];
    var bundleLabel = (item.properties || {})['_bundle_label'];
    if (bundleChildren || bundleLabel) {
      var b = li.querySelector('[data-gr-cart-line-bundle]');
      var count = 0;
      try { count = JSON.parse(bundleChildren || '[]').length; } catch (_) {}
      b.textContent = bundleLabel || (count ? 'Includes ' + count + ' items' : 'Bundle');
      b.hidden = false;
    }

    // Price — show original + discounted if line has discounts
    var priceEl = li.querySelector('[data-gr-cart-line-price]');
    var lineDiscount = item.original_line_price - item.final_line_price;
    if (lineDiscount > 0) {
      var wasSpan = document.createElement('span');
      wasSpan.className = 'gr-cart-line__price-was';
      wasSpan.textContent = money(item.original_line_price);
      var nowSpan = document.createElement('span');
      nowSpan.className = 'gr-cart-line__price-now';
      nowSpan.textContent = money(item.final_line_price);
      priceEl.textContent = '';
      priceEl.appendChild(wasSpan);
      priceEl.appendChild(nowSpan);
      // Show discount name
      if (item.discount_allocations && item.discount_allocations.length) {
        var discName = document.createElement('span');
        discName.className = 'gr-cart-line__discount-tag';
        discName.textContent = item.discount_allocations[0].discount_application.title;
        priceEl.appendChild(discName);
      }
    } else {
      priceEl.textContent = money(item.final_line_price);
    }

    // Qty controls
    var input = li.querySelector('[data-gr-qty-input]');
    input.value = item.quantity;
    var dec = li.querySelector('[data-gr-qty-dec]');
    var inc = li.querySelector('[data-gr-qty-inc]');
    dec.addEventListener('click', function () { setQty(item.key, li, item.quantity - 1); item.quantity = Math.max(0, item.quantity - 1); });
    inc.addEventListener('click', function () { setQty(item.key, li, item.quantity + 1); item.quantity = item.quantity + 1; });
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (!isFinite(v) || v < 0) v = 0;
      setQty(item.key, li, v);
    });

    // Remove
    li.querySelector('[data-gr-cart-line-remove]').addEventListener('click', function () {
      setQty(item.key, li, 0, true);
    });

    return li;
  }

  // ─── Qty change (debounced, optimistic) ─────────────────────
  var qtyTimers = {};
  function setQty(key, li, qty, removing) {
    li.classList.add('is-loading');
    if (removing) li.classList.add('is-removing');
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      fetch(ROOT + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartCache = cart; paint(cart); })
        .catch(function () { li.classList.remove('is-loading', 'is-removing'); });
    }, 220);
  }

  // ─── Subscribe toggle ────────────────────────────────────────
  if (el.subToggle) {
    el.subToggle.addEventListener('change', async function () {
      var enabled = el.subToggle.checked;
      el.subToggle.disabled = true;

      try {
        var cartData = await fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        var eligibleItems = cartData.items.filter(function (it) {
          if (enabled) return !it.selling_plan_allocation && /coffee|roast|blend/i.test(it.product_type || '');
          else return !!it.selling_plan_allocation && /coffee|roast|blend/i.test(it.product_type || '');
        });

        for (var i = 0; i < eligibleItems.length; i++) {
          var item = eligibleItems[i];

          if (enabled) {
            // Find the "every 4 weeks" selling plan for this product
            var pData = await fetch(ROOT + '/products/' + item.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
            var planId = null;
            if (pData.selling_plan_groups) {
              for (var g = 0; g < pData.selling_plan_groups.length; g++) {
                var plans = pData.selling_plan_groups[g].selling_plans;
                for (var p = 0; p < plans.length; p++) {
                  if (plans[p].name.toLowerCase().indexOf('4 week') !== -1) {
                    planId = plans[p].id;
                    break;
                  }
                }
                if (planId) break;
              }
            }
            if (!planId) continue;

            // Remove one-time item and re-add with selling plan
            await fetch(ROOT + '/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
            await fetch(ROOT + '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: item.variant_id, quantity: item.quantity, selling_plan: planId }] })
            });
          } else {
            // Remove subscription item and re-add without selling plan
            await fetch(ROOT + '/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
            await fetch(ROOT + '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: item.variant_id, quantity: item.quantity }] })
            });
          }
        }

        render();
      } catch (err) {
        console.error('[gr-cart] sub toggle error', err);
      } finally {
        el.subToggle.disabled = false;
      }
    });
  }

  // ─── Upsells ────────────────────────────────────────────────
  var upsellCache = null;
  function loadUpsells() {
    var cfg = getUpsellConfig();
    if (!cfg.enabled) return;
    if (upsellCache) return renderUpsells(upsellCache);

    if (cfg.mode === 'products' && cfg.products.length > 0) {
      Promise.all(cfg.products.map(function (handle) {
        return fetch(ROOT + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (results) {
        upsellCache = results.filter(Boolean);
        renderUpsells(upsellCache);
      });
    } else {
      fetch(ROOT + '/collections/' + cfg.collection + '/products.json?limit=6', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          upsellCache = data.products || [];
          renderUpsells(upsellCache);
        })
        .catch(function () {});
    }
  }

  function findVariant(product, selectedOpts) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (vr) {
      return (product.options || []).every(function (optName, i) {
        return vr['option' + (i + 1)] === selectedOpts[i];
      });
    }) || product.variants[0];
  }

  function renderUpsells(products) {
    if (!cartCache || cartCache.item_count === 0) return;
    var inCart = new Set(cartCache.items.map(function (it) { return it.product_id; }));
    var cfg = getUpsellConfig();
    var picks = products.filter(function (p) { return !inCart.has(p.id); }).slice(0, cfg.limit || 3);
    if (!picks.length) { el.upsell.hidden = true; return; }
    el.upsell.hidden = false;
    el.upsellGrid.innerHTML = '';
    picks.forEach(function (p) {
      var v = (p.variants && p.variants[0]) || {};
      var imgSrc = '';
      if (p.images && p.images.length) {
        imgSrc = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
      } else if (p.featured_image) {
        imgSrc = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
      }
      var priceVal = v.price || p.price || 0;
      var priceCents = typeof priceVal === 'string' ? Math.round(parseFloat(priceVal) * 100) : priceVal;

      var hasMultipleVariants = p.variants && p.variants.length > 1 && !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
      var productUrl = p.url || '/products/' + p.handle;

      var card = document.createElement('div');
      card.className = 'gr-cart__upsell-card';

      // Clickable image + title link to product
      var link = document.createElement('a');
      link.href = productUrl;
      link.className = 'gr-cart__upsell-link';
      var img = document.createElement('img');
      img.src = imgSrc; img.alt = p.title; img.loading = 'lazy';
      link.appendChild(img);
      card.appendChild(link);

      var titleEl = document.createElement('a');
      titleEl.className = 'title'; titleEl.textContent = p.title; titleEl.href = productUrl;
      card.appendChild(titleEl);

      var priceEl = document.createElement('span');
      priceEl.className = 'price'; priceEl.textContent = money(priceCents);
      card.appendChild(priceEl);

      if (hasMultipleVariants) {
        // Inline variant picker
        var pickerWrap = document.createElement('div');
        pickerWrap.className = 'gr-cart__upsell-picker';
        pickerWrap.hidden = true;

        // Build option selectors
        var selectedOpts = {};
        (p.options || []).forEach(function (optName, optIdx) {
          var seen = {};
          var optRow = document.createElement('div');
          optRow.className = 'gr-cart__upsell-opt';
          var label = document.createElement('span');
          label.className = 'gr-cart__upsell-opt-label';
          label.textContent = optName;
          optRow.appendChild(label);
          var chips = document.createElement('div');
          chips.className = 'gr-cart__upsell-chips';

          p.variants.forEach(function (vr) {
            var val = vr['option' + (optIdx + 1)];
            if (!val || seen[val]) return;
            seen[val] = true;
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'gr-cart__upsell-chip';
            chip.textContent = val;
            chip.dataset.optIndex = optIdx;
            chip.dataset.optValue = val;
            if (!selectedOpts[optIdx]) {
              selectedOpts[optIdx] = val;
              chip.classList.add('is-active');
            }
            chip.addEventListener('click', function () {
              selectedOpts[optIdx] = val;
              chips.querySelectorAll('.gr-cart__upsell-chip').forEach(function (c) { c.classList.remove('is-active'); });
              chip.classList.add('is-active');
              // Update price
              var match = findVariant(p, selectedOpts);
              if (match && pickerPrice) pickerPrice.textContent = money(typeof match.price === 'string' ? Math.round(parseFloat(match.price) * 100) : match.price);
            });
            chips.appendChild(chip);
          });
          optRow.appendChild(chips);
          pickerWrap.appendChild(optRow);
        });

        var pickerPrice = document.createElement('span');
        pickerPrice.className = 'price';
        pickerPrice.textContent = money(priceCents);
        pickerWrap.appendChild(pickerPrice);

        var pickerAdd = document.createElement('button');
        pickerAdd.type = 'button';
        pickerAdd.className = 'add';
        pickerAdd.textContent = 'Add to cart';
        pickerAdd.addEventListener('click', function () {
          var match = findVariant(p, selectedOpts);
          if (!match || !match.available) return;
          pickerAdd.disabled = true;
          pickerAdd.textContent = 'Adding...';
          fetch(ROOT + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: match.id, quantity: 1 }] })
          }).then(function (r) { return r.json(); })
            .then(function () { pickerAdd.textContent = 'Added ✓'; pickerAdd.classList.add('is-added'); render(); })
            .catch(function () { pickerAdd.disabled = false; pickerAdd.textContent = 'Add to cart'; });
        });
        pickerWrap.appendChild(pickerAdd);
        card.appendChild(pickerWrap);

        // Toggle button to show/hide picker
        var toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.className = 'add';
        toggleBtn.textContent = 'Select options';
        toggleBtn.addEventListener('click', function () {
          pickerWrap.hidden = !pickerWrap.hidden;
          toggleBtn.hidden = true;
        });
        card.appendChild(toggleBtn);
      } else {
        // Single variant — direct add to cart
        var addBtn = document.createElement('button');
        addBtn.type = 'button'; addBtn.className = 'add'; addBtn.textContent = 'Add';
        if (!v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
        card.appendChild(addBtn);
        addBtn.addEventListener('click', function (ev) {
          var btn = ev.currentTarget;
          if (btn.disabled) return;
          btn.disabled = true;
          fetch(ROOT + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              btn.classList.add('is-added');
              btn.textContent = 'Added ✓';
              render();
            })
            .catch(function () { btn.disabled = false; });
        });
      }

      el.upsellGrid.appendChild(card);
    });
  }

  // Empty-state mini grid: reuse upsell collection, 3 items
  function loadEmptyPicks() {
    if (!el.emptyGrid) return;
    fetch(ROOT + '/collections/' + (getUpsellConfig().collection || 'coffee-bags') + '/products.json?limit=3', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        el.emptyGrid.textContent = '';
        (data.products || []).slice(0, 3).forEach(function (p) {
          var a = document.createElement('a');
          a.href = '/products/' + p.handle;
          var img = document.createElement('img');
          var imgSrc = '';
          if (p.images && p.images.length > 0) {
            imgSrc = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
          } else if (p.image && p.image.src) {
            imgSrc = p.image.src;
          }
          img.src = imgSrc;
          img.alt = p.title;
          img.width = 60;
          img.height = 60;
          img.loading = 'lazy';
          a.appendChild(img);
          var span = document.createElement('span');
          span.textContent = p.title;
          a.appendChild(span);
          el.emptyGrid.appendChild(a);
        });
      })
      .catch(function () {});
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // ─── Timer block ─────────────────────────────────────────────
  var timerEl = drawer.querySelector('[data-gr-cart-timer]');
  if (timerEl) {
    var timerDisplay = timerEl.querySelector('[data-gr-timer-display]');
    var totalSecs = (parseInt(timerEl.dataset.minutes, 10) || 15) * 60;
    var remaining = totalSecs;
    var timerInterval = null;

    function updateTimer() {
      if (remaining <= 0) {
        timerDisplay.textContent = '0:00';
        clearInterval(timerInterval);
        return;
      }
      remaining--;
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      timerDisplay.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }

    // Start timer when drawer opens with items
    var origOpen = open;
    var timerStarted = false;
    window.addEventListener('gr:cart:open', function () {
      if (!timerStarted && cartCache && cartCache.item_count > 0) {
        timerStarted = true;
        timerInterval = setInterval(updateTimer, 1000);
      }
    });
  }

  // ─── Discount code block ────────────────────────────────────
  var discountInput = drawer.querySelector('[data-gr-cart-discount-input]');
  var discountApply = drawer.querySelector('[data-gr-cart-discount-apply]');
  var discountNote = drawer.querySelector('[data-gr-cart-discount-note]');
  var discountApplied = drawer.querySelector('[data-gr-cart-discount-applied]');
  var discountRemoved = false;
  if (discountNote) discountNote.dataset.original = discountNote.textContent;
  if (discountInput && discountApply) {
    discountApply.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) return;

      discountApply.disabled = true;
      discountApply.textContent = '...';

      discountRemoved = false;
      // Apply discount code then verify it actually worked
      fetch(ROOT + '/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow' })
        .then(function () {
          // Wait for Shopify to process, then verify via cart
          return new Promise(function (resolve) { setTimeout(resolve, 1000); });
        })
        .then(function () {
          return fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          // Check if discount is present in cart
          var applied = (cart.cart_level_discount_applications || []).some(function (d) {
            return d.title.toUpperCase() === code.toUpperCase();
          });
          var hasDiscount = cart.total_discount > 0;

          if (applied || hasDiscount) {
            // Valid — show success
            discountInput.value = '';
            if (discountNote) discountNote.hidden = true;
            if (discountApplied) {
              discountApplied.hidden = false;
              discountApplied.textContent = '';
              var codeSpan = document.createElement('span');
              codeSpan.textContent = '✦ "' + code.toUpperCase() + '" — ' + money(cart.total_discount) + ' off';
              discountApplied.appendChild(codeSpan);
              var removeBtn = document.createElement('button');
              removeBtn.type = 'button';
              removeBtn.className = 'gr-cart__discount-remove';
              removeBtn.textContent = '✕';
              removeBtn.setAttribute('aria-label', 'Remove discount');
              removeBtn.addEventListener('click', function () { removeDiscount(); });
              discountApplied.appendChild(removeBtn);
            }
            discountApply.textContent = 'Applied ✓';
            cartCache = cart;
            paint(cart);
          } else {
            // Invalid — clear the bad code and show error
            document.cookie = 'discount_code=; path=/; max-age=0';
            if (discountNote) {
              discountNote.textContent = 'Invalid code. Try again.';
              discountNote.hidden = false;
            }
            discountApply.textContent = 'Invalid';
          }
          setTimeout(function () {
            discountApply.disabled = false;
            discountApply.textContent = 'Apply';
          }, 2000);
        })
        .catch(function () {
          if (discountNote) {
            discountNote.textContent = 'Invalid code. Try again.';
            discountNote.hidden = false;
          }
          discountApply.disabled = false;
          discountApply.textContent = 'Apply';
        });
    });
    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); discountApply.click(); }
    });

    function removeDiscount() {
      discountRemoved = true;
      document.cookie = 'discount_code=; path=/; max-age=0';
      fetch(ROOT + '/checkout?discount=', { method: 'GET', redirect: 'manual' }).catch(function () {});
      if (discountApplied) {
        discountApplied.hidden = true;
        discountApplied.textContent = '';
      }
      if (discountNote) {
        discountNote.textContent = discountNote.dataset.original || '';
        discountNote.hidden = false;
      }
      render();
    }
  }

  // Initial fetch (so header count is correct even before open)
  fetchCart().then(function (cart) {
    cartCache = cart;
    document.querySelectorAll('[data-gr-cart-count]').forEach(function(n) {
      n.textContent = cart.item_count;
    });
  });
})();
